<template>
    <section class="recover-pswd-comp">
        <SwipeModalComponent v-if="groupsMenu.isVisible" @closeMenu="closeGroupsMenu" :blockScroll="true">
            <div class="content-wrapper">
                <h2> {{ groupsMenu.fatherName }}</h2>

                <div class="list" v-if="this.groupsMenu.groups.length > 0">
                <div class="groups" v-for="(item, key) in this.groupsMenu.groups" :key="key">
                    <div class="list-item" @click="item.showProducts = !item.showProducts" v-if="item.isVisible">
                        <div class="list-item-field">
                            <h1 v-text="item.grupo.NMGRUPROMOC"></h1>
                        </div>
                        <div class="list-item-field">
                            <i :class="item.showProducts ? 'fa fa-chevron-down icon' : 'fa fa-chevron-right icon'"></i>
                        </div>
                    </div>

                    <transition name="slide-fade">
                        <div class="wrapper" v-if="item.showProducts">
                            <div class="products" v-for="(product, key) in item.produtos" :key="key" @click="handleProductClick(product)">
                                <h1 v-text="product.NMPRODUTO"></h1>
                                <h1 v-text="product.VRPRECITEM.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })"></h1>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

                <div class="footer-itens-container">
                    <button @click="closeGroupsMenu">Fechar</button>
                </div>
            </div>
        </SwipeModalComponent>
        <ModalInfo></ModalInfo>
    </section>
</template>
<script>
import ModalInfo from '@/components/modals/ModalInfo.vue'
import SwipeModalComponent from './SwipeModalComponent.vue'

import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'ProductGroupComponent',
    components: {
        ModalInfo,
        SwipeModalComponent
    },
    data () {
        return {
        }
    },
    computed: {
        ...mapGetters(['groupsMenu'])
    },
    methods: {
        ...mapActions(['closeGroupsMenu', 'showProductModal']),
        handleProductClick: function (product) {
            this.showProductModal(product)
        }
    }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    max-height: calc(100vh - 100px);

    h2 {
        text-align: center;
        margin-bottom: 20px;
    }

    .list {
        max-height: calc(100vh - 300px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .list-item {
            display: flex;
            justify-content: space-between;
            padding: 20px 10px;
            border-bottom: solid #BAB8B8 2px;

            &:last-of-type {
                margin-bottom: 20px;
            }
        }

        .products {
            display: flex;
            justify-content: space-between;
            margin-top: 15px;
            padding: 15px 10px;
            border: 1px solid rgba(0, 0, 0, 0.18);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 5px;
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            h1 {
                font-weight: normal;
            }

            &:last-of-type {
                margin-bottom: 20px;
            }
        }
    }

    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all .1s linear;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
        transform: translateY(20px);
    }

    .not-found {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .footer-itens-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        button {
            text-align: right;
            border-radius: 30px;
            color: var(--primaryColor);
            padding: 10px 0;
            margin: 10px 15px 20px 15px;
            font-weight: 600;
            border: none;
            background-color: transparent;
        }
    }
}
</style>
